import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _Text, _CloseSmall;
var _excluded = ["onChange", "onBlur", "value", "error", "check", "errorText", "label", "maxLength", "id", "name", "type", "onEmailChange", "full", "didYouMean", "data-testid", "description"];
// TODO: enable this rule and fix the code

import { useEffect, useRef, useState } from 'react';
import { CloseSmall } from '@crehana/icons/outline';
import { OPTION, OPTION_WRAPPER } from "../Dropdown/classnames";
import useOnClickOutside from "../hooks/useOnClickOutside";
import { redMain } from "../styles/colors";
import transition from "../styles/transition";
import Text from "../Text";
import TextField from "../TextField";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BASE_WRAPPER = 'inline-flex flex-col w-full z-1';
var WRAPPER_DEFAULT = /*#__PURE__*/"".concat(BASE_WRAPPER, " cursor-pointer");
var WRAPPER_OPEN = /*#__PURE__*/"".concat(BASE_WRAPPER, " z-4 cursor-pointer shadow-dropdown");
var WRAPPER_DISABLED = /*#__PURE__*/"".concat(BASE_WRAPPER, " cursor-default");
var OPTION_HOVER_STYLE = 'text-primary-main bg-gray-lighter';
var WRAPPER = {
  "default": WRAPPER_DEFAULT,
  open: WRAPPER_OPEN,
  disabled: WRAPPER_DISABLED
};
var styleType = 'default';
var EmailField = function EmailField(_ref) {
  var onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    value = _ref.value,
    error = _ref.error,
    check = _ref.check,
    errorText = _ref.errorText,
    label = _ref.label,
    maxLength = _ref.maxLength,
    id = _ref.id,
    name = _ref.name,
    type = _ref.type,
    onEmailChange = _ref.onEmailChange,
    full = _ref.full,
    _ref$didYouMean = _ref.didYouMean,
    didYouMean = _ref$didYouMean === void 0 ? '¿Quiso decir' : _ref$didYouMean,
    dataTestId = _ref['data-testid'],
    description = _ref.description,
    props = _objectWithoutProperties(_ref, _excluded);
  var EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  var domains = ['gmail', 'hotmail', 'yahoo', 'outlook'];
  var _useState = useState({
      value: '',
      username: '',
      domain: '',
      error: {
        code: null,
        message: ''
      },
      complete: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    suggestedEmail = _useState4[0],
    setSuggestedEmail = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    listDomainsAvailable = _useState6[0],
    setListDomainsAvailable = _useState6[1];
  var containerRef = useRef(null);
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    displayDomains = _useState8[0],
    setDisplayDomains = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    arrowSelection = _useState10[0],
    setArrowSelection = _useState10[1];
  var domainsLength = domains ? domains.length : 0;
  var handler = function handler() {
    if (displayDomains) {
      setDisplayDomains(false);
    }
  };
  useOnClickOutside(containerRef, handler);
  var setValidateEmail = function setValidateEmail(validEmail) {
    if (validEmail) {
      var username = '';
      var domain = '';
      var emailValue = '';
      if (validEmail && typeof validEmail !== 'string') {
        username = validEmail.username;
        domain = validEmail.emailDomain;
        emailValue = "".concat(username).concat(domain);
      } else {
        emailValue = validEmail;
      }
      setEmail({
        value: emailValue,
        username: username,
        domain: domain,
        error: {
          code: null,
          message: ''
        },
        complete: true
      });
    }
  };
  var validateEmailFormat = function validateEmailFormat(emailValue) {
    return EMAIL_PATTERN.test(emailValue);
  };
  var suggestDomainEmail = function suggestDomainEmail(emailValue) {
    var USERNAME_PATTERN = new RegExp('.+@', 'gi');
    var DOMAIN_NAME_PATTERN = new RegExp('@[A-Z0-9-]+', 'gi');
    var FULL_DOMAIN_PATTERN = new RegExp('@.+', 'gi');
    if (emailValue) {
      var domainMatches = {
        domain: null,
        matches: 0
      };
      var matchUsername = USERNAME_PATTERN.exec(emailValue);
      var matchDomain = DOMAIN_NAME_PATTERN.exec(emailValue);
      var matchLastDomain = FULL_DOMAIN_PATTERN.exec(emailValue);
      var COINCIDENCES_NUMBER = 3;
      var username = matchUsername ? matchUsername[0] : '';
      var emailDomain = matchDomain ? matchDomain[0] : '';
      var lastDomain = matchLastDomain ? matchLastDomain[0] : '';
      username = username.slice(0, -1);
      lastDomain = lastDomain.replace(emailDomain, '');
      emailDomain = emailDomain.replace('@', '');
      for (var i = 0; i < domainsLength; i += 1) {
        var domain = domains[i];
        if (domain === emailDomain) {
          return {
            username: username,
            emailDomain: "@".concat(emailDomain, ".com")
          };
        }
        var count = 0;
        var inputDomain = emailDomain.split('');
        for (var j = 0; j < inputDomain.length; j += 1) {
          if (domain.includes(inputDomain[j])) {
            count += 1;
          }
        }
        if (count > COINCIDENCES_NUMBER && count > domainMatches.matches) {
          domainMatches = {
            domain: domain,
            matches: count
          };
        }
      }
      var customLastDomain = '.com';
      if (domainMatches.domain && lastDomain.length > 0) {
        emailDomain = "@".concat(domainMatches.domain).concat(customLastDomain);
        return {
          username: username,
          emailDomain: emailDomain
        };
      }
    }
    return null;
  };
  var getDomainsList = function getDomainsList(inputValue) {
    var USERNAME_PATTERN = new RegExp('.+@', 'gi');
    var DOMAIN_NAME_PATTERN = new RegExp('@[A-Z0-9-]+', 'gi');
    var matchUsername = USERNAME_PATTERN.exec(inputValue);
    var matchDomain = DOMAIN_NAME_PATTERN.exec(inputValue);
    var username = matchUsername ? matchUsername[0] : '';
    var emailDomain = matchDomain ? matchDomain[0] : '';
    emailDomain = emailDomain.replace('@', '');
    var availableDomains = [];
    if (!username) return null;
    if (emailDomain) {
      for (var i = 0; i < domainsLength; i += 1) {
        var domain = domains[i];
        var includeDomain = domain.includes(emailDomain);
        if (includeDomain) {
          var addDomainToEmail = "".concat(username).concat(domain, ".com");
          availableDomains.push(addDomainToEmail);
        }
      }
    } else {
      for (var _i = 0; _i < domainsLength; _i += 1) {
        var _domain = domains[_i];
        var _addDomainToEmail = "".concat(username).concat(_domain, ".com");
        availableDomains.push(_addDomainToEmail);
      }
    }
    return availableDomains;
  };
  var validateEmail = function validateEmail(event) {
    var _lastDomain;
    var defaultValue = event.target.defaultValue;
    var inputValue = event.target.value;
    var emailMessageError = '';
    var emailErrorType = null;
    var DOMAIN_NAME_PATTERN = new RegExp('@[A-Z0-9-]+', 'gi');
    var matchDomain = DOMAIN_NAME_PATTERN.exec(inputValue);
    var FULL_DOMAIN_PATTERN = new RegExp('@.+', 'gi');
    var matchLastDomain = FULL_DOMAIN_PATTERN.exec(inputValue);
    var emailDomain = matchDomain ? matchDomain[0] : '';
    var lastDomain = matchLastDomain ? matchLastDomain[0] : '';
    lastDomain = (_lastDomain = lastDomain) === null || _lastDomain === void 0 ? void 0 : _lastDomain.replace(emailDomain, '');
    inputValue = inputValue.replace(/\s/, '');
    var isEmailValid = validateEmailFormat(inputValue);
    if (defaultValue.length <= inputValue.length) {
      if (inputValue === '') {
        emailMessageError = 'Correo electrónico obligatorio';
        emailErrorType = 'required';
        setListDomainsAvailable(null);
        setSuggestedEmail(null);
      } else if (!isEmailValid) {
        emailMessageError = 'Correo electrónico inválido';
        emailErrorType = 'invalid';
      }
      var similarEmail = lastDomain ? suggestDomainEmail(inputValue) : null;
      var emailSuggested = similarEmail ? "".concat(similarEmail.username).concat(similarEmail.emailDomain) : null;
      setSuggestedEmail(similarEmail);
      if (inputValue === emailSuggested) {
        setSuggestedEmail(null);
      }
      if (!similarEmail) {
        var domainList = !isEmailValid ? getDomainsList(inputValue) : [];
        setListDomainsAvailable(domainList || null);
        setDisplayDomains(!!(domainList && domainList.length));
      }
      setEmail({
        value: inputValue,
        username: similarEmail ? similarEmail.username : '',
        domain: similarEmail ? similarEmail.emailDomain : '',
        complete: isEmailValid,
        error: {
          message: emailMessageError,
          code: emailErrorType
        }
      });
    } else {
      if (!matchDomain) {
        setListDomainsAvailable(null);
        setSuggestedEmail(null);
      }
      setEmail(_objectSpread(_objectSpread({}, email), {}, {
        complete: isEmailValid,
        value: inputValue
      }));
    }
  };
  var handleKeyUp = function handleKeyUp(event) {
    var keyName = event.key;
    if (listDomainsAvailable) {
      var countDomains = listDomainsAvailable.length;
      if (keyName === 'ArrowDown' && arrowSelection < countDomains) {
        setArrowSelection(arrowSelection + 1);
      } else if (keyName === 'ArrowUp') {
        if (arrowSelection > 1) {
          setArrowSelection(arrowSelection - 1);
        }
      }
    }
    if (displayDomains && (keyName === 'Escape' || keyName === 'Enter' || keyName === 'Tab')) {
      event.preventDefault();
      setDisplayDomains(false);
      setArrowSelection(0);
    }
  };
  useEffect(function () {
    if (displayDomains && listDomainsAvailable) {
      var emailSelected = listDomainsAvailable[arrowSelection - 1];
      setValidateEmail(emailSelected || null);
    }
  }, [arrowSelection, displayDomains, listDomainsAvailable]);
  useEffect(function () {
    if (typeof onEmailChange === 'function') {
      onEmailChange(email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);
  var onCustomChange = function onCustomChange(event) {
    validateEmail(event);
    if (typeof onEmailChange === 'function') {
      onEmailChange(email);
    }
    if (typeof onChange === 'function') {
      onChange(event);
    }
  };
  var onBlurEmail = function onBlurEmail(event) {
    validateEmail(event);
    if (typeof onBlur === 'function') {
      onBlur(event);
    }
  };
  if (displayDomains) {
    styleType = 'open';
  }
  if (suggestedEmail || !displayDomains || !listDomainsAvailable) {
    styleType = 'default';
  }
  var domainListTopStyle = 58;
  var suggestedEmailTopStyle = 56;
  if (description || label) {
    domainListTopStyle = description ? 116 : 86;
    suggestedEmailTopStyle = description ? 112 : 84;
  }
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(full ? 'w-full' : 'w-auto'),
    children: /*#__PURE__*/_jsxs("div", {
      ref: containerRef,
      className: "".concat(WRAPPER[styleType], " relative ").concat(suggestedEmail ? 'mb-20' : '', " "),
      children: [/*#__PURE__*/_jsx(TextField, _objectSpread({
        "data-testid": dataTestId || 'email-field',
        id: id || 'email',
        name: name || 'email',
        type: type || 'text',
        value: value || email.value,
        onChange: function onChange(event) {
          return onCustomChange(event);
        },
        errorText: !suggestedEmail ? errorText || email.error.message : '',
        error: !!(error || email.error.message),
        check: check || email.complete,
        label: label,
        maxLength: maxLength || 75,
        onBlur: onBlurEmail,
        onKeyDown: function onKeyDown(e) {
          return handleKeyUp(e);
        },
        description: description
      }, props)), displayDomains && listDomainsAvailable && !suggestedEmail && /*#__PURE__*/_jsx("div", {
        className: "absolute w-full h-200",
        style: {
          top: domainListTopStyle
        },
        children: /*#__PURE__*/_jsx("ul", {
          className: " ".concat(OPTION_WRAPPER),
          children: listDomainsAvailable.map(function (domain, i) {
            return /*#__PURE__*/_jsx("li", {
              "data-testid": "recommended-emails",
              className: "".concat(OPTION, " ").concat(arrowSelection - 1 === i ? OPTION_HOVER_STYLE : ''),
              style: {
                transition: transition(['background-color', 'color'])
              },
              children: /*#__PURE__*/_jsx("button", {
                type: "button",
                "data-testid": "recommended-email-button",
                className: "w-full h-full text-left",
                onClick: function onClick() {
                  setValidateEmail(domain);
                  setListDomainsAvailable(null);
                  setArrowSelection(0);
                },
                children: /*#__PURE__*/_jsx(Text, {
                  className: "overflow-hidden pointer-events-auto max-h-24",
                  color: "inherit",
                  children: domain
                })
              })
            }, "option-".concat(domain));
          })
        })
      }), suggestedEmail && /*#__PURE__*/_jsxs("p", {
        className: "absolute right-0 flex justify-end my-4",
        style: {
          top: suggestedEmailTopStyle
        },
        "data-testid": "suggested-email",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "span",
          type: "body3",
          className: "mr-4",
          color: "red-main",
          children: didYouMean
        }), /*#__PURE__*/_jsx(Text, {
          as: "span",
          type: "body3",
          onClick: function onClick() {
            setValidateEmail(suggestedEmail);
            setSuggestedEmail(null);
            setListDomainsAvailable(null);
          },
          color: "red-main",
          "data-testid": "suggested-email-button",
          children: suggestedEmail.username
        }), /*#__PURE__*/_jsx(Text, {
          as: "span",
          type: "body3",
          onClick: function onClick() {
            setValidateEmail(suggestedEmail);
            setSuggestedEmail(null);
            setListDomainsAvailable(null);
          },
          color: "red-main",
          className: "font-bold",
          children: suggestedEmail.emailDomain
        }), _Text || (_Text = /*#__PURE__*/_jsx(Text, {
          as: "span",
          type: "body3",
          className: "mr-4",
          color: "red-main",
          children: "?"
        })), /*#__PURE__*/_jsx(Text, {
          className: "flex my-auto ml-4",
          onClick: function onClick() {
            return setSuggestedEmail(null);
          },
          children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
            color: redMain,
            size: 16
          }))
        })]
      })]
    })
  });
};
export default EmailField;